import { axiosInstance } from '@configs/axios/axiosInstance';

/**
 * Sync user information from Salesforce to CAE Connect.
 * Endpoint: POST /users/{id}/sync
 *
 * Used to resolve NameDiscrepancy — updates CAE Connect data
 * to match the Salesforce contact information.
 * Returns 202 on success.
 */
export async function syncUser(id: string): Promise<void> {
  await axiosInstance.post(`/users/${encodeURIComponent(id)}/sync`);
}
